module.exports = __webpack_public_path__ + "img/mobile-42.8b11f900.png";